// import { ApiService } from "../api";
// import { FileExtensionEnum } from "../enums";

import config from "../../config";

async function downloadFile(path: string, filename: string) {

  const url = [config.REACT_APP_DMS_URL, path].join('');

  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: '*/*',
      }
    });

    const blob = await res.blob();
    const newBlob = new Blob([blob]);

    const blobUrl = window.URL.createObjectURL(newBlob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', `${filename}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);

    // clean up Url
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error(error); // eslint-disable-line no-console
  }
}

async function downloadFileDms(uuid: string) {
  console.log(uuid);
  // ApiService.getTempUrl(uuid).subscribe({
  //   next: (response: any) => {
  //     const link = document.createElement('a');
  //     link.href = response.url;
  //     link.setAttribute('download', uuid);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.parentNode?.removeChild(link);

  //     // clean up Url
  //     window.URL.revokeObjectURL(response.url);
  //   },
  //   error: (error: Error) => {
  //   }
  // })
}

export const DownloadService = {
  downloadFile,
  downloadFileDms
};
